export default "__VITE_ASSET__CmNVKGt9__"